import PubSub from "pubsub-js";
function handleVisibilityChange() {
  let active = true;
  let activeHandler;
  return function inactiveHandler() {
    if (document.hidden) {
      console.log("page switched out");
      if (!activeHandler) {
        activeHandler = setTimeout(
          () => {
            console.log("page inactive");
            active = false;
            PubSub.publish("onPageInactive");
          },
          1000 * 5 * 60,
        );
      }
    } else {
      console.log("page switched in");
      clearTimeout(activeHandler);
      activeHandler = null;
      if (!active) {
        console.log("page active");
        active = true;
        PubSub.publish("onPageActive");
      }
    }
  };
}

document.addEventListener("visibilitychange", handleVisibilityChange(), false);
